import { Component } from '@ecs/Component';

/** Marks the mothership hull on the base screen. */
export class Mothership implements Component {
  readonly type = 'Mothership';
}
